const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Modal = require("./Modal");
const ModalClose = require("./ModalClose");
const AssetsUtil = require("../util/AssetsUtil");
const StringUtil = require("../../../shared/StringUtil");
const Checkbox = require("./Checkbox");
const DemoSignupModalButton = require("./DemoSignupModalButton");
const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const CopyTable = require("../util/CopyTable");
const Copy = CopyTable.forDemoEmailModal();
const OfficeCopyTable = require("../../office/data/CopyTable");
const roles = OfficeCopyTable.getMailingListRoles();
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const AT = require("../vault/ActionTypes");
const LoadingCircle = require("./LoadingCircle");
const {ErrorIcon} = require("./ErrorIcon");

const styles = require("./styles/DemoEmailModal.css");
const MIN_WAIT_TIME = 2000;

//Initial Steps: enterEmail, pickRole, signingUp,
//After Completion: signUpSuccess, signUpFail, duplicateEmail (special fail)

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "DemoEmailModalView",

		propTypes: {
			modalShown: PT.bool.isRequired,
			onClose: PT.func.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			emailSignUpStarted: function() {
				this.setState({step: "signingUp"});
			},
			emailSignUpComplete: function(nextStep) {
				const timeElapsed = Date.now() - this.state.startedSignUp;
				const newState = {step: nextStep, isOpen: true};
				if (timeElapsed < MIN_WAIT_TIME) {
					setTimeout(
						() => this.setState(newState),
						MIN_WAIT_TIME - timeElapsed
					);
				} else {
					this.setState(newState);
				}
			},
			emailSignUpEnd: function() {
				this.setState({isOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isOpen: true,
				step: "enterEmail",
				email: "",
				emailInvalid: false,
				role: null,
				roleInvalid: false,
				agree: false,
				agreeError: false,
				startedSignUp: null,
			};
		},

		closeModal: function() {
			this.setState({
				step: "enterEmail",
			});
			this.props.onClose();
		},

		makeBody: function() {
			const {step, emailInvalid, roleInvalid, agreeError} = this.state;

			let body;
			if (step === "enterEmail") {
				const inputStyle =
					styles.input + (emailInvalid ? " " + styles.invalid : "");
				const invalidMessage = !this.state.email
					? Copy.emailMissing
					: Copy.emailInvalid;
				const frameUrl = AssetsUtil.getDemo(
					"demo-email-field" + (emailInvalid ? "-invalid" : "")
				);
				body = (
					<div>
						<div className={styles.header}>{Copy.enterEmail}</div>
						<div className={styles.inputOuter}>
							<div className={styles.inputWrap}>
								<img className={styles.inputFrame} src={frameUrl} />
								<input
									className={inputStyle}
									type="text"
									placeholder="Email"
									autoComplete="section-emailModal"
									onChange={this.handleChange}
									onKeyPress={this.handleKeyPress}
									tabIndex={1}
								/>
							</div>
							<div className={styles.asideContainer}>
								<div
									className={
										emailInvalid ? styles.errorVisible : styles.errorHidden
									}
								>
									{invalidMessage}
								</div>
								<a className={styles.privacy} href="/privacy">
									See our Privacy Policy
								</a>
							</div>
						</div>
					</div>
				);
			} else if (step === "pickRole") {
				const roleOptions = roles.map((r, i) => {
					const isSelected = r === this.state.role;
					const onClick = () => this.handlePickRole(r);
					let overallClass = styles.role;
					overallClass += isSelected ? " " + styles.selected : "";
					return (
						<div className={overallClass} onClick={onClick} key={"role-" + i}>
							<div className={styles.circle} />
							{r}
						</div>
					);
				});
				const errorClass =
					roleInvalid || agreeError ? styles.roleError : styles.roleErrorHidden;
				const errorText = roleInvalid
					? Copy.roleNotChosen
					: Copy.agreeNotChecked;
				const rolesContainer = (
					<div className={styles.roles}>{roleOptions}</div>
				);
				body = (
					<div>
						<div className={styles.header}>{Copy.pickRole}</div>
						{rolesContainer}
						<Checkbox
							className={styles.checkbox}
							text={Copy.agreement}
							textClass={styles.disclaimerText}
							checkColor={"mainBlue"}
							onClick={() => this.setAgree(!this.state.agree)}
							isSelected={this.state.agree}
							styleType={"demo"}
						/>
						<div className={errorClass}>{errorText}</div>
					</div>
				);
			} else if (step === "signingUp") {
				body = (
					<div className={styles.loading}>
						<LoadingCircle colorType="color" />{" "}
					</div>
				);
			} else if (step === "signUpSuccess") {
				body = (
					<div>
						<div className={styles.header}>{Copy.signUpSuccess}</div>
						<div className={styles.imgContainer}>
							<img
								className={styles.happyImg}
								alt="BA Headmaster on Computer"
								src={AssetsUtil.getOfficeCharacter("headmaster-computer")}
							/>
						</div>
					</div>
				);
			} else if (step === "signUpFail") {
				body = (
					<div>
						<div className={styles.header}>{Copy.signUpFail}</div>
						<ErrorIcon className={styles.failIcon} />
					</div>
				);
			} else if (step === "duplicateEmail") {
				body = (
					<div>
						<div className={styles.header}>{Copy.duplicateEmail}</div>
						<div className={styles.warningIconContainer}>
							<img
								className={styles.warningIcon}
								alt=""
								src={AssetsUtil.getOfficeIcon("warning-icon")}
							/>
						</div>
					</div>
				);
			}
			return body;
		},

		makeButton: function() {
			const {step} = this.state;
			const getButton = buttonText => {
				return (
					<DemoSignupModalButton
						onClick={this.onContinue}
						buttonText={buttonText}
					/>
				);
			};

			if (["enterEmail", "pickRole"].includes(this.state.step)) {
				return getButton("CONTINUE");
			} else if (step === "signUpSuccess" || step === "duplicateEmail") {
				return getButton("OKAY");
			} else if (step === "signUpFail") {
				return getButton("TRY AGAIN");
			} else {
				return null;
			}
		},

		handleChange: function(evt) {
			this.setState({email: evt.target.value, emailInvalid: false});
		},

		handleKeyPress: function(evt) {
			if (evt.which === 13) {
				this.onContinue();
			}
		},

		handlePickRole: function(r) {
			if (this.state.role === r) {
				this.setState({role: null});
			} else {
				this.setState({role: r, roleInvalid: false});
			}
		},

		setAgree: function(newAgree) {
			this.setState({
				agree: newAgree,
				agreeError: false,
			});
		},

		onSignUp: function() {
			this.props.dispatch({
				type: AT.DEMO_EMAIL_SIGN_UP_REQUEST,
				email: this.state.email,
				role: this.state.role,
			});
			this.setState({startedSignUp: Date.now()});
		},

		onContinue: function() {
			const {step, role, email, agree} = this.state;
			if (step === "enterEmail") {
				if (StringUtil.isValidEmail(email)) {
					this.setState({step: "pickRole"});
				} else {
					this.setState({emailInvalid: true});
				}
			} else if (step === "pickRole") {
				if (!role) {
					this.setState({roleInvalid: true});
				} else if (!agree) {
					this.setState({agreeError: true});
				} else {
					this.onSignUp();
				}
			} else if (step === "signUpFail") {
				this.onSignUp();
			} else if (step === "signUpSuccess" || step === "duplicateEmail") {
				this.closeModal();
			}
		},

		render: function() {
			if (!this.props.modalShown) return null;

			const bgEl = (
				<img className={styles.bg} src={AssetsUtil.getModal("demo-box")} />
			);

			return (
				<Portal container={PORTAL_CONTAINERS.DEMO_SIGNUP_MODAL}>
					<div className={styles.main}>
						<Modal
							onClose={this.closeModal}
							closeOnBackdropClick={true}
							closeOnEsc={true}
							backdropClass={styles.backdrop}
							modalClass={styles.content}
							levelType="default"
						>
							{bgEl}
							{this.makeBody()}
							{this.makeButton()}
							<ModalClose onClick={this.closeModal} modalType={"demo"} />
						</Modal>
					</div>
				</Portal>
			);
		},
	})
);
